export default __webpack_public_path__ + "static/media/Tradeop-1.15699365.png";